import { render, staticRenderFns } from "./sendInstructions.vue?vue&type=template&id=07215990&scoped=true&"
import script from "./sendInstructions.vue?vue&type=script&lang=js&"
export * from "./sendInstructions.vue?vue&type=script&lang=js&"
import style0 from "./sendInstructions.vue?vue&type=style&index=0&id=07215990&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07215990",
  null
  
)

export default component.exports